export default [
  {
    path: '/admin/statistical/operation-log/index',
    name: 'M020009',
    component: () =>
      import('@/views/admin/statistical/operation-log/OperationLogIndex.vue'),
    meta: {
      layout: 'admin',
      dataAuth: {
        bizCode: 'unit',
        operationCode: 'query',
      },
      targetName: '操作日志',
    },
  },
  {
    path: '/admin/statistical/user-login-record/index',
    name: 'M020007',
    component: () =>
      import(
        '@/views/admin/statistical/user-login-record/UserLoginRecordIndex.vue'
      ),
    meta: {
      layout: 'admin',
      dataAuth: {
        bizCode: 'audit',
        operationCode: 'query',
      },
      targetName: '登录统计',
    },
  },
  {
    path: '/admin/statistical/online-user/index',
    name: 'M020069',
    component: () =>
      import(
        '@/views/admin/statistical/online-user/OnlineUserIndex.vue'
      ),
    meta: {
      layout: 'admin',
      targetName: '在线人数统计',
    },
  },
];
